export const getHighScore = () => {
  return parseInt(localStorage.getItem("flappyHighScore")) || 0;
};

export const setHighScore = (score) => {
  localStorage.setItem("flappyHighScore", score);
};
